import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,setEventsLib} from '../function_lib/common_lib';
import Comp_Update_Ratings from '../components/comp_update_ratings';
import Header from '../user_pages/header';
import Footer from '../user_pages/footer';
import Option_Module from '../user_pages/option_module';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';



let loginUser="";
let userObject="";
let companyName="";
let clsViewRatings;

let rf="0";

class View_Ratings extends React.Component{
    forceUpdateHandler(){
        this.forceUpdate();
      };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
            userObject= getUserObjData();
            //alert(JSON.stringify(userObject));
            loginUser=userObject[0].first_name;
            companyName=userObject[0].first_name;
        }
        clsViewRatings=this;
        this.state={ stListRatings:[],stRating:{}};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
      }

      deleteRating(item){
        if(window.confirm("Are you sure want to delete selected ratings ")){
        let map=[];
        map.push({name:"curl_type",value:"deleteRating"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"p_rating_id",value:btoa(item.id)});
        map["res_func"]="callBackrrr";
        map["curl_type"]="deleteRating";
        CallMapMethod_CBack(clsViewRatings,map,function(data,msg){
          if(data==="001"){
            alert("Deleted Successfully");
            clsViewRatings.getRatings();
          }
        });

        }
      }

      getRatings(status="0"){
        //child component use this method loan_document_upload_comp
       
          var map=[];
          map.push({name:"curl_type",value:"viewRatings"});
          map.push({name:"res_func",value:"callBackrrr"});
          map.push({name:"local_token",value:userObject[0].app_user_id});
          map.push({name:"user_type",value:userObject[0].type});
          map.push({name:"upper_id",value:userObject[0].upper_id});
          map["res_func"]="callBackrrr";
          map["curl_type"]="viewRatings";
          CallMapMethod_CBack(clsViewRatings,map,function(data,msg){
            //alert(data);
              if(data!=="0" && data!==""){
                  let listData=JSON.parse(data);
                  var strData="";
                  clsViewRatings.setState({stListRatings:listData},()=>{
                      clsViewRatings.forceUpdateHandler();
                  });
                }
          });
        
        
      }
      
okUpdRatingStatus(data,msg){
  if(data==="001"){
    $("#rat_status").val("0");
    alert("Status Updated Successfully");
    clsViewRatings.getRatings();
  }
}
onViewUpdateM(item){
  clsViewRatings.setState({stRating:item});
}     
      
componentDidMount(){
   this.getRatings();

  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
              <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Ratings and Reviews</b></h3>
                
                {/* <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divWaThrashold" href="javascript:void(0)">Add New</a> */}
              </div>
                <table class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                    <th>Sn</th>
								  <th>Name/Email</th>
								  <th>Product Name</th>
								  <th>Rating</th>
								  <th>Review</th>
								  <th>status</th>
								  <th>Date</th>
								  <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="tbData">
                  {(this.state.stListRatings.map((item,index)=>{
                       return(<tr>
                        <td>{index+1}</td>
                    <td>{item.customer_name+" "+item.contact_no}</td>
                    <td>{item.product_name}</td>
                    <td>{item.rating}</td>
                    <td>{item.comment}</td>
                  <td>{item.status}</td>
                  <td>{item.month_date}</td>
                  <td>
                  <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" area-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu">
                   
                     <a class="dropdown-item" onClick={()=>this.onViewUpdateM(item)}  data-toggle="modal" data-target="#divUpdateRatings" href="javascript:void(0)">Approve/Reject</a>
                     <a class="dropdown-item" onClick={()=>this.deleteRating(item)}  href="javascript:void(0)">Delete</a>
                    </div>
                  </div>

                  </td>
                    </tr>)
                  }))}
                  </tbody>
                </table>
           
              
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Footer/>
<Comp_Update_Ratings user_object={userObject} lsRatings={this.state.stRating} />
          </div>)
      }
}
export default View_Ratings;